/**
 * Urban Browser Guard — safe-browsing / PII protection
 *
 * Declares three WAR groups with no use_dynamic_url: three notification pages
 * (content/*-notification/index.html) exposed to every URL, plus executors/* and
 * /sdk/* exposed to http(s) origins. The notification pages are vendor-named and
 * served from a fixed URL, so a single fetch is conclusive — the resource only
 * resolves when the extension is installed.
 *
 * Manifest verified against version 8.2.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'almalgbpmcfpdaopimbdchdliminoign';

export const urbanBrowserGuard: ExtensionDefinition = {
  id: ID,
  name: 'Urban Browser Guard',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Three static notification pages on every URL, plus executors and sdk on http(s) ' +
    'origins, none dynamic. Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-safe-check-notification',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/safe-check-notification/index.html — a vendor-named notification ' +
        'page exposed to every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'content/safe-check-notification/index.html'),
    },
    {
      id: 'war-pii-detected-notification',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/pii-detected-notification/index.html — a second static notification ' +
        'page, corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/pii-detected-notification/index.html'),
    },
    {
      id: 'war-pii-consent-notification',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/pii-consent-notification/index.html — a third independent static path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/pii-consent-notification/index.html'),
    },
  ],
};
